import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Folder } from 'react-feather';
import { projectApi } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { FeatherArrowLeft } from '../components/ui/icons';
import './MyProjects.css';

const MyProjects = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (user?.id) {
            fetchProjects();
        }
    }, [user?.id]);

    const fetchProjects = async () => {
        try {
            setLoading(true);
            setError('');
            const data = await projectApi.getMyProjects();
            setProjects(data || []);
        } catch (err) {
            console.error('Error fetching projects:', err);
            setError('Failed to load projects');
        } finally {
            setLoading(false);
        }
    };

    const handleViewNotesArtifacts = (projectId) => {
        navigate(`/my-projects/${projectId}/notes-artifacts`);
    };

    if (loading) {
        return (
            <div className="my-projects-page">
                <div className="my-projects-loading">Loading...</div>
            </div>
        );
    }

    return (
        <div className="my-projects-page">
            <div className="my-projects-header">
                <Button
                    variant="neutral-tertiary"
                    icon={<FeatherArrowLeft />}
                    onClick={() => navigate('/dashboard')}
                    className="back-button"
                >
                    Back to Dashboard
                </Button>
                <div className="my-projects-header-content">
                    <h1 className="my-projects-title">My Projects</h1>
                    <p className="my-projects-subtitle">
                        View notes and artifacts for projects you're working on
                    </p>
                </div>
            </div>

            {error && (
                <div className="my-projects-error">
                    {error}
                </div>
            )}

            {projects.length === 0 ? (
                <div className="my-projects-empty">
                    <Folder size={64} />
                    <h2>No Projects</h2>
                    <p>You're not currently working on any projects.</p>
                    <p className="my-projects-empty-hint">
                        Projects will appear here once you have tasks assigned or work plans with project tasks.
                    </p>
                </div>
            ) : (
                <div className="my-projects-grid">
                    {projects.map((project) => (
                        <div key={project.id} className="my-project-card">
                            <div className="my-project-card-header">
                                <div className="my-project-card-title-section">
                                    <Folder size={20} className="my-project-icon" />
                                    <div>
                                        <h3 className="my-project-name">{project.name}</h3>
                                        {project.abbreviation && (
                                            <span className="my-project-badge">{project.abbreviation}</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {project.description && (
                                <p className="my-project-description">{project.description}</p>
                            )}
                            <div className="my-project-card-actions">
                                <Button
                                    variant="brand-primary"
                                    onClick={() => handleViewNotesArtifacts(project.id)}
                                    icon={<FileText size={16} />}
                                >
                                    View Notes & Artifacts
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MyProjects;

